import React from 'react';

interface IScenarioAside {
  isScenariosExisting: boolean;
  activeScenariosCount: number;
  currentCount: number;
}

export const ScenarioAside = ({
  isScenariosExisting,
  activeScenariosCount,
  currentCount,
}: IScenarioAside) => {
  if (!isScenariosExisting) return null;

  return (
    <div className="scenarios-screen__status">
      Запущено виджетов: {activeScenariosCount}/{currentCount}
    </div>
  );
};
